import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

export const useGetGroupType = ({ enabled = false }) => {
    return useQuery({
        queryKey: ['group-type'],
        queryFn: async () => {
            const { data } = await authAxios.get(`api/v1/master-data/group-type`);
            return data?.data;
        },
        enabled: enabled,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};
